module.exports = __webpack_public_path__ + "img/inverter_green.a5c82451.png";